import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getExcelAction } from "../../../../redux/actions/productAction";
import ExcelRunTime from "./ExcelRunTimeModal";

export const ExcelGrid = () => {
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedExcelId, setSelectedExcelId] = useState(0);
  const [open, setOpen] = useState(false);

  const handleOpenModal = (id) => {
    setSelectedExcelId(id);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setSelectedExcelId(0);
  };

  const getExcels = useCallback(async () => {
    if (!authUserId || !token) return;
    setLoading(true);
    try {
      const response = await dispatch(getExcelAction(authUserId, token));
      setData(response?.data?.data ?? []);
    } catch {
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [authUserId, token, dispatch]);

  useEffect(() => {
    getExcels();
  }, [getExcels]);
  const handleDownload = (path) => {
    if (path) {
      window.location.href = path;
    } else {
      alert("Dosya yolu bulunamadı!");
    }
  };

  const getExcelStateText = (state) => {
    switch (state) {
      case 0:
        return "Bekliyor";
      case 1:
        return "Devam Ediyor";
      case 9:
        return "Tamamlandı";
      default:
        return "-";
    }
  };

  /** ProductProcessing=1, StockProcessing=2, ProductDownload=3 */
  const getExcelTypeText = (type) => {
    switch (type) {
      case 1:
        return "Ürün İşleme";
      case 2:
        return "Stok İşleme";
      case 3:
        return "Ürün İndirme";
      default:
        return "-";
    }
  };

  return (
    <TableContainer
      sx={{
        mt: { xs: 2, sm: 3, md: 5 },
        maxHeight: { xs: 400, sm: 500, md: 670 },
        width: "100%",
        p: { xs: 1, sm: 2, md: "0px 10px 10px 10px" },
        background: "white",
        borderRadius: { xs: 2, sm: 3, md: 5 },
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
        overflowX: "auto",
      }}
    >
      <Typography
        sx={{
          padding: { xs: 1, sm: 1.5, md: 2 },
          fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
        }}
        variant="h6"
        align="center"
        color="primary"
        gutterBottom
      >
        Excel Durum
      </Typography>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200, p: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
      <Table
        stickyHeader
        aria-label="excel data table"
        size="small"
        sx={{
          "& .MuiTableCell-root": {
            fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
            padding: { xs: 1, sm: 1.5, md: 2 },
            whiteSpace: "nowrap",
          },
          "& .MuiTableHead-root .MuiTableCell-root": {
            backgroundColor: "#f5f5f5",
            fontWeight: "bold",
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>Excel Adı</TableCell>
            <TableCell>Tür</TableCell>
            <TableCell>Yüklenme Tarihi</TableCell>
            <TableCell>Durum</TableCell>
            <TableCell>İndir</TableCell>
            <TableCell>Excel Hata Listesi</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((item, index) => (
            <TableRow
              key={index}
              sx={{
                background: "white",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              <TableCell>{item?.name}</TableCell>
              <TableCell>{getExcelTypeText(item?.type)}</TableCell>
              <TableCell>
                {new Date(item?.createDate).toLocaleDateString("tr-TR", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </TableCell>
              <TableCell>
                <Typography
                  sx={{
                    color:
                      item.state === 9
                        ? "success.main"
                        : item.state === 1
                        ? "warning.main"
                        : "text.primary",
                    fontWeight: "medium",
                  }}
                >
                  {getExcelStateText(item.state)}
                </Typography>
              </TableCell>
              <TableCell>
                <Button
                  onClick={() => handleDownload(item?.downloadPath)}
                  size="small"
                  sx={{
                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                    padding: { xs: "4px 8px", sm: "6px 12px" },
                    minWidth: { xs: "60px", sm: "80px" },
                  }}
                >
                  İndir
                </Button>
              </TableCell>
              <TableCell>
                <Button
                  onClick={() => handleOpenModal(item.id)}
                  size="small"
                  sx={{
                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                    padding: { xs: "4px 8px", sm: "6px 12px" },
                    minWidth: { xs: "60px", sm: "80px" },
                  }}
                >
                  Göster
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      )}
      <ExcelRunTime
        open={open}
        handleCloseModal={handleCloseModal}
        excelId={selectedExcelId}
      />
    </TableContainer>
  );
};
